document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_BackgroundVideo', () => ({
    playing: false,
    player: {
      ['x-ref']: 'video',
      [':class']: `{ 'opacity-0': !playing, 'opacity-100': playing }`,
    },

    init() {
      this.$nextTick(() => {
        const video = this.$refs.video;

        // Re-assert, in JS, everything Safari's autoplay policy needs.
        video.muted = true;
        video.defaultMuted = true;
        video.setAttribute('muted', '');
        video.playsInline = true;
        video.setAttribute('playsinline', '');

        // Fade the video in as soon as it is actually playing.
        const reveal = () => { this.playing = true; };
        video.addEventListener('playing', reveal);
        video.addEventListener('loadeddata', () => { if (!video.paused) reveal(); });
        video.addEventListener('pause', () => { this.playing = false; });
        if (!video.paused) reveal();

        if (video.autoplay) this.attemptPlay();
      });
    },

    attemptPlay() {
      const video = this.$refs.video;
      video.muted = true;

      // Try to start it now.
      const p = video.play();
      if (p && typeof p.then === 'function') {
        p.then(() => { this.playing = true; }).catch(() => {});
      }

      // Safety net: if it's still paused a moment later -- whether Safari
      // rejected autoplay or quietly re-paused it -- start it on the first
      // interaction the visitor makes anywhere on the page.
      setTimeout(() => {
        if (video.paused) this.installGestureFallback();
      }, 400);
    },

    installGestureFallback() {
      const video = this.$refs.video;
      const events = ['pointerdown', 'touchstart', 'keydown', 'scroll', 'wheel', 'mousemove'];

      const cleanup = () => events.forEach((e) => window.removeEventListener(e, kick));
      const kick = () => {
        video.muted = true;
        video.play().then(() => { this.playing = true; }).catch(() => {});
        if (!video.paused) cleanup();
      };

      events.forEach((e) => window.addEventListener(e, kick, { passive: true }));
    },

    play() { this.attemptPlay(); },
    pause() { this.$refs.video.pause(); },
  }));
});